export default __webpack_public_path__ + "static/media/potato.465ec93e.png";